import React from "react";
import PropTypes from "prop-types";

import { UIStatusTag } from "../../../ui";
import { TIMESHEET_CHECKOUT_STATUSES } from "./constants";

import "./TimesheetCheckoutStatusBadge.scss";

const CHECKOUT_STATUS_STYLES = {
  [TIMESHEET_CHECKOUT_STATUSES.self]: {
    background: "var(--color-cyan-subtle)",
    borderColor: "var(--color-background-subtle)",
    color: "var(--color-cyan-800)",
  },
  [TIMESHEET_CHECKOUT_STATUSES.auto]: {
    background: "var(--color-destructive-subtle)",
    borderColor: "var(--color-destructive-subtle)",
    color: "var(--color-destructive-active)",
  },
};

const TimesheetCheckoutStatusBadge = ({ status, label }) => {
  if (status === TIMESHEET_CHECKOUT_STATUSES.pending) {
    return (
      <UIStatusTag
        status="pending"
        label={label}
        preset="table"
        className="timesheet-checkout-status-badge"
      />
    );
  }

  const style = CHECKOUT_STATUS_STYLES[status];

  return (
    <UIStatusTag
      status={status}
      label={label}
      preset="table"
      className="timesheet-checkout-status-badge"
      style={style}
    />
  );
};

TimesheetCheckoutStatusBadge.propTypes = {
  status: PropTypes.oneOf(Object.values(TIMESHEET_CHECKOUT_STATUSES)).isRequired,
  label: PropTypes.node.isRequired,
};

export default TimesheetCheckoutStatusBadge;
